<div class="ads-page">
  <div class="page-header">
    <div class="page-title-block">
      <span class="page-kicker">Performance</span>
      <h2 class="page-title">Padronização de dados contábeis</h2>
      <p class="page-description">
        Documentos contábeis extraídos e organizados pelo Cog IA, com edição assistida e auditoria
        de alterações manuais.
      </p>
    </div>
    @if (stateService.view() === 'detail' && stateService.activeCompanyName()) {
      <div class="page-company">
        <i class="pi pi-building"></i>
        <span>{{ stateService.activeCompanyName() }}</span>
      </div>
    }
  </div>

  @if (stateService.view() === 'list') {
    <div class="company-filter">
      <app-select-company
        [multiple]="true"
        [selectionScope]="'page-filter'"
        [selectedCompanyValues]="stateService.selectedCompanyIds()"
        (sendSelectedOptionMultiple)="onCompaniesChange($event)" />
    </div>

    <!-- Abas da listagem (PBI 3423): fila de exceção, propostas de conta e dicionário, cada uma com a sua permissão. -->
    @if (hasListTabs()) {
      <div class="list-tabs" role="tablist" aria-label="Visão da listagem">
        <button
          type="button"
          role="tab"
          class="list-tab"
          [class.list-tab--active]="listTab() === 'documents'"
          [attr.aria-selected]="listTab() === 'documents'"
          (click)="setListTab('documents')">
          Documentos
        </button>
        @if (canSeeExceptionQueue()) {
          <button
            type="button"
            role="tab"
            class="list-tab"
            data-testid="list-tab-exceptions"
            [class.list-tab--active]="listTab() === 'exceptions'"
            [attr.aria-selected]="listTab() === 'exceptions'"
            (click)="setListTab('exceptions')">
            Retidos
          </button>
        }
        @if (canSeePromotions()) {
          <button
            type="button"
            role="tab"
            class="list-tab"
            data-testid="list-tab-promotions"
            [class.list-tab--active]="listTab() === 'promotions'"
            [attr.aria-selected]="listTab() === 'promotions'"
            (click)="setListTab('promotions')">
            Propostas de conta
          </button>
        }
        @if (canSeeDictionary()) {
          <button
            type="button"
            role="tab"
            class="list-tab"
            data-testid="list-tab-dictionary"
            [class.list-tab--active]="listTab() === 'dictionary'"
            [attr.aria-selected]="listTab() === 'dictionary'"
            (click)="setListTab('dictionary')">
            Dicionário
            @if (dictionaryAttentionCount() > 0) {
              <span
                class="list-tab__count"
                data-testid="list-tab-dictionary-count"
                [attr.aria-label]="
                  dictionaryAttentionCount() + ' mudanças do dicionário esperando revisão'
                ">
                {{ dictionaryAttentionCount() }}
              </span>
            }
          </button>
        }
      </div>
    }
  }

  @if (stateService.view() === 'list' && listTab() === 'exceptions' && canSeeExceptionQueue()) {
    <app-exception-queue-panel
      [companyIds]="stateService.selectedCompanyIds()"
      (openRequested)="onOpenQueueDocument($event)" />
  } @else if (stateService.view() === 'list' && listTab() === 'promotions' && canSeePromotions()) {
    <app-standard-account-promotions-panel />
  } @else if (stateService.view() === 'list' && listTab() === 'dictionary' && canSeeDictionary()) {
    <app-standard-account-dictionary-panel
      (openDocumentRequested)="onOpenQueueDocument($event)"
      (summaryChanged)="onDictionarySummaryChanged($event)" />
  } @else if (stateService.view() === 'list') {
    <div class="section-header">
      <h3>Documentos contábeis</h3>
      <p>Extraídos e organizados pelo Cog IA · {{ countLabel() }}</p>
    </div>

    @if (stateService.processingCount() > 0) {
      <div class="processing-banner" role="status" aria-live="polite">
        <i class="pi pi-spin pi-spinner"></i>
        <span>
          {{ stateService.processingCount() }}
          {{ stateService.processingCount() === 1 ? 'documento' : 'documentos' }} em processamento…
          a lista atualiza sozinha conforme o pipeline conclui.
        </span>
      </div>
    }

    <!-- Anos sem documento validado na Análise Econômica (card 3700). -->
    <app-years-without-document-banner
      class="missing-years-banner"
      [years]="stateService.yearsWithoutValidatedDocument()"
      [showCompanyName]="stateService.selectedCompanyIds().length !== 1"
      (documentOpenRequested)="onOpenQueueDocument($event)"
      (yearFilterRequested)="stateService.setFilterYears([$event])" />

    <app-document-list
      [documents]="stateService.documents()"
      [isLoading]="stateService.isLoadingList()"
      [isReprocessing]="stateService.isReprocessing()"
      [search]="stateService.search()"
      [filterType]="stateService.filterType()"
      [filterStatuses]="stateService.filterStatuses()"
      [filterYears]="stateService.filterYears()"
      [availableYears]="stateService.availableYears()"
      [page]="stateService.page()"
      [pages]="stateService.pages()"
      [total]="stateService.total()"
      [pageSize]="stateService.pageSize()"
      [selectedCompanyIds]="stateService.selectedCompanyIds()"
      [sortField]="stateService.sortField()"
      [sortDirection]="stateService.sortDirection()"
      (sortChanged)="stateService.setSort($event)"
      (documentSelected)="onOpenDocument($event)"
      (documentOpenRequested)="onOpenQueueDocument($event)"
      (reprocessSelected)="onReprocessSelected($event)"
      (searchChanged)="stateService.setSearch($event)"
      (typeChanged)="stateService.setFilterType($event)"
      (statusesChanged)="stateService.setFilterStatuses($event)"
      (yearsChanged)="stateService.setFilterYears($event)"
      (pageChanged)="stateService.setPage($event)"
      (pageSizeChanged)="stateService.setPageSize($event)" />
  } @else {
    <!-- Detalhe do documento: componente próprio desde o PBI 3061, para a modal "Ver De/Para" da Análise
         Econômica reaproveitar a mesma peça (cada um com sua instância do state service). -->
    <app-accounting-document-detail />
  }
</div>
